import { DEFAULT_COUNTRY_COVID_OBJ } from '../constants';

export default function countriesExtendCovidData(objTo, arrayFrom) {
  const extended = objTo.features.map((feature) => {
    let copyFeature = { ...feature };
    const objFrom = arrayFrom.find((item) => item.iso3 === feature.properties.ISO_A3);
    if (objFrom === undefined) {
      copyFeature = {
        ...copyFeature, properties: { ...copyFeature.properties, ...DEFAULT_COUNTRY_COVID_OBJ },
      };
    } else {
      copyFeature = { ...copyFeature, properties: { ...copyFeature.properties, ...objFrom } };
    }
    return copyFeature;
  });
  const extendedObj = { ...objTo, features: extended };
  return extendedObj;
}
